import i18next from 'i18next'
import { parseEvent } from './shared'
import { eventTitle, isCriticalEvent } from '@/lib/criticalEvents'
import type { DesktopAlert } from '@/types'

/** #297 D4 — what the desktop notification for a live event says: the toast's title (the translated event
 * type; #294: the critical title for a critical event), the camera (+ group) as the body, the event
 * thumbnail as the image, the event id as its tag. #294 D6: a critical event's stays until clicked.
 * Read outside React (it runs inside the WebSocket message handler), hence i18next directly. */
export function desktopAlertOf(event: unknown): Pick<DesktopAlert, 'eventId' | 'title' | 'body' | 'image' | 'critical'> {
  const parsed = parseEvent(event)
  const title = eventTitle(
    { ...(event as object | null), event_type: parsed.eventType },
    (key, options) => i18next.t(key as never, { ns: 'common', ...options } as never),
    parsed.title,
  )
  const body = [parsed.camera, parsed.cameraGroup].filter(Boolean).join(' · ')
  const id = (event as { id?: unknown } | null)?.id
  const critical = isCriticalEvent(event)
  return {
    eventId: typeof id === 'number' ? id : undefined,
    title,
    body,
    image: parsed.thumbnailUrl || undefined,
    ...(critical ? { critical: true } : {}),
  }
}
